/**
 * Main entry point - v2 build reset
 */
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Initialize i18next
import "./lib/i18n";

// Apply homeContent i18n patches (12 + 5 additional languages)
import { applyHomeContentPatch } from "./data/homeContent-i18n-patch";
import { applyHomeContentTier2Patch } from "./data/homeContent-tier2-patch";
applyHomeContentPatch();
applyHomeContentTier2Patch();

const root = document.getElementById("root");
if (root) {
  createRoot(root).render(<App />);
}

// Register Service Worker on the canonical production domain only.
// This avoids preview/staging cache pollution and keeps SEO rollouts fresh.
const CANONICAL_SW_HOSTS = new Set(['callitdev.com', 'www.callitdev.com']);

if ('serviceWorker' in navigator && import.meta.env.PROD && CANONICAL_SW_HOSTS.has(window.location.hostname.toLowerCase())) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // SW registration failed — non-critical, app works without it
    });
  });
}
